
import { getSharedAudioContext } from "./memoryService";
import { resampleCubic } from "../utils/dspUtils";
import { APP_CONFIG } from "./config";

/**
 * Decodes an Audio File into a Float32Array (Mono).
 * Uses the shared AudioContext to minimize resource usage.
 * ENFORCES: Target Sample Rate Normalization (Determinism).
 */
export async function decodeAudioFile(file: File | Blob): Promise<Float32Array> {
    const ctx = await getSharedAudioContext();
    const arrayBuffer = await file.arrayBuffer();
    
    // Copy the buffer if needed, though decodeAudioData handles it. 
    // We assume arrayBuffer is fresh from the file read.
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);
    const pcm = audioBuffer.getChannelData(0); // Return Mono channel for analysis

    // HARD DETERMINISM: Ensure sample rate matches the engine's expectation (44100Hz)
    // If the device or file is 48kHz (common), we must resample to avoid scoring drift.
    if (audioBuffer.sampleRate !== APP_CONFIG.TARGET_SAMPLE_RATE) {
        // console.debug(`[AUDIO-DECODER] Resampling ${audioBuffer.sampleRate}Hz -> ${APP_CONFIG.TARGET_SAMPLE_RATE}Hz`);
        return resampleCubic(pcm, audioBuffer.sampleRate, APP_CONFIG.TARGET_SAMPLE_RATE);
    }

    return pcm;
}
